<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Pages configuration"
  >
    <ul
      v-sortable="{ method: 'orderTabs' }"
    >
      <li
        v-for="(tab, tabKey) in tabs"
        :key="tabKey"
        class="draggable"
        :data-tab-key="tabKey"
      >
        {{ tab.title }}
        <ul
          v-if="subTabs && subTabs[tabKey]"
          v-sortable="{ method: 'orderSubTabs', args: { tabKey } }"
          :data-tab-key="tabKey"
        >
          <li
            v-for="(subTab, subTabKey) in subTabs[tabKey]"
            :key="subTabKey"
            class="draggable"
            :data-sub-tab-key="subTabKey"
          >
            <span>{{ subTabs[tabKey][subTabKey].title }}</span>
            <b-dropdown
              size="sm"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
              class="tab-config-btn"
              v-b-tooltip.hover
              title="Change parent"
            >
              <template v-slot:button-content>
                <icon name="cog" />
              </template>
              <b-dropdown-item
                v-for="(parentTab, parentTabKey) in tabs"
                :key="parentTabKey"
                href="#"
                @click="changeParent(tabKey, subTabKey, parentTabKey)"
              >
                <span>{{ parentTab.title }}</span>
                <b-badge
                  v-if="tabKey === parentTabKey"
                  variant="primary"
                >
                  <icon name="check" />
                </b-badge>
              </b-dropdown-item>
            </b-dropdown>
          </li>
        </ul>
      </li>
    </ul>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  data () {
    return {
      tabs: null,
      subTabs: null
    }
  },
  computed: {
    ...mapState([
      'currentSubTab'
    ])
  },
  methods: {
    open () {
      if (this.$refs.modal) this.$refs.modal.show()
    },
    close () {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    orderTabs ({ el }) {
      const tabEls = $(el).find('> li')
      const tabs = {}

      tabEls.each((order, tabEl) => {
        const tabKey = $(tabEl).data('tab-key')
        const tab = this.tabs[tabKey]
        tab.order = order
        tabs[tabKey] = tab
      })

      db.tabs.saveTabs(tabs)
    },
    orderSubTabs ({ el, tabKey }) {
      const subTabEls = $(el).find('> li')
      const subTabs = {}

      subTabEls.each((order, subTabEl) => {
        const subTabKey = $(subTabEl).data('sub-tab-key')
        const subTab = this.subTabs[tabKey][subTabKey]
        subTab.order = order
        subTabs[subTabKey] = subTab
      })

      db.tabs.saveSubTabs(tabKey, subTabs)
    },
    changeParent (tabKey, subTabKey, newParentKey) {
      db.widgets.changeParentTab(tabKey, newParentKey)
      db.tabs.changeParentTab(tabKey, subTabKey, newParentKey, () => {
        if (this.currentSubTab === subTabKey) {
          const dInst = this.$instByClass(this, 'dashboard-component')

          dInst.setCurrentSubTab(subTabKey, newParentKey)
        }
      })
    }
  },
  created () {
    db.tabs.read((tabs) => {
      this.tabs = tabs
    })

    db.tabs.readSubTabs((subTabs) => {
      const tbs = _.cloneDeep(this.tabs)
      this.tabs = null
      this.subTabs = subTabs
      this.$nextTick(() => {
        this.tabs = tbs
      })
    })
  }
}
</script>

<style lang="scss">
.tab-config-btn {
  button {
    vertical-align: 5px;
    padding: 0;
    &:after {
      display: none;
    }
  }
  .dropdown-item {
    position: relative;
    padding-right: 30px;
    .badge {
      position: absolute;
      right: 10px;
      top: 5px;
    }
  }
}
</style>
